// extracted by mini-css-extract-plugin
export default {"logo-wrapper":"UserLogo_logo-wrapper__IVSJB","logo-error":"UserLogo_logo-error__TFYaT"};